module.exports = __webpack_public_path__ + "pc/img/main-magazine-img-01.d4e8f098.jpg";